var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-modal-hightligher"},[_vm._v(" "+_vm._s(_vm.isCustom ? '直接使用：' : '')+_vm._s(_vm.segments[0])),_c('span',{staticClass:"blue"},[_vm._v(_vm._s(_vm.keyword))]),_vm._v(_vm._s(_vm.segments[1])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }